import * as React from "react";
import { Viewport, ViewSmall, ViewMedium } from "bernie-view";
import { DestinationDescriptionProps, DestinationDescriptionViewProps } from "./typings";
import { inject } from "mobx-react";
import { formatText } from "bernie-l10n";
import {
  Action,
  FlexTrackingInfo,
  sendDelayedTrackEvent
} from "components/utility/analytics/FlexAnalyticsUtils";
import { UitkExpandoPeek } from "uitk-react-expando";
import { AnalyticsConfig } from "uitk-react-utils";
import { JumplinkItem } from "components/flexComponents/Jumplinks/Jumplinks";

// These values are a starting point for mobile and desktop,
// and are pulled from the new Figma design.
export const SMALL_COLLAPSE_HEIGHT = 120;
export const MEDIUM_COLLAPSE_HEIGHT = 280;

@inject("analytics", "dx")
export class DestinationDescription extends React.Component<DestinationDescriptionProps> {
  private readonly jumplinkRef: React.RefObject<HTMLDivElement>;
  private jumplink: JumplinkItem;

  constructor(props: DestinationDescriptionProps) {
    super(props);
    this.jumplinkRef = React.createRef();
  }

  /* istanbul ignore next line */
  public componentDidMount() {
    const componentHasData: boolean =
      this.props.flexComponent.model.content &&
      !this.props.flexComponent.model.empty &&
      this.props.flexComponent.model.content &&
      this.props.flexComponent.model.content.body &&
      this.props.flexComponent.model.content.body.length > 0;

    this.jumplink = {
      identifier: 0,
      name: "Overview",
      icon: "info_outline",
      reference: this.jumplinkRef,
      localisedName: formatText("jumplinks.overview")
    };

    const checkForExistingReference = (reference: JumplinkItem) => {
      return reference["name"] === this.jumplink.name;
    };

    const addUpdatedReference = (reference: JumplinkItem) => {
      if (this.props.dx && reference["name"] === this.jumplink.name) {
        const index = this.props.dx.jumplinksArray.indexOf(reference);
        this.props.dx.jumplinksArray.splice(index, 1);
        this.props.dx.jumplinksArray.push(this.jumplink);
      }
    };

    if (this.props.dx && componentHasData && this.props.flexComponent.model.jumpLinkable) {
      if (
        this.props.dx.jumplinksArray.some((reference: JumplinkItem) =>
          checkForExistingReference(reference)
        )
      ) {
        this.props.dx.jumplinksArray.map((reference: JumplinkItem) =>
          addUpdatedReference(reference)
        );
      } else {
        this.props.dx.jumplinksArray.push(this.jumplink);
      }
    }
  }

  /* istanbul ignore next line */
  public componentWillUnmount() {
    if (this.props.dx && this.props.flexComponent.model.jumpLinkable) {
      if (this.props.dx.jumplinksArray.includes(this.jumplink)) {
        this.props.dx.jumplinksArray.splice(this.props.dx.jumplinksArray.indexOf(this.jumplink), 1);
      }
    }
  }

  public render() {
    const { flexComponent } = this.props;
    const { content, jumpLinkable } = flexComponent.model;

    const body = (content && content.body) || [];

    const destinationDescription = body.map((desc: string, id: number) => {
      const description = desc.replace("<p>", "").replace("</p>", "");

      return (
        <p
          key={`destination-description-body-${id}`}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      );
    });

    const teaser =
      content && content.teaser && content.teaser.join() !== content.body.join()
        ? content.teaser.join()
        : "";

    /* istanbul ignore next */
    const analytics: AnalyticsConfig = {
      id: "TG.LP.Dest.Description",
      callback: id => {
        const flexTrackingInfo: FlexTrackingInfo = {
          moduleName: id,
          action: Action.CLICK
        };
        sendDelayedTrackEvent(flexTrackingInfo, this.props.analytics);
      }
    };

    return (
      <div
        id={flexComponent.id}
        data-fm={flexComponent.fmId}
        ref={jumpLinkable ? this.jumplinkRef : null}
        className="DestinationDescription uitk-cell all-cell-1-1 uitk-type-300"
      >
        <Viewport>
          <ViewSmall>
            <DestinationDescriptionView
              threshold={SMALL_COLLAPSE_HEIGHT}
              analytics={analytics}
              description={destinationDescription}
              teaser={teaser}
            />
          </ViewSmall>

          <ViewMedium>
            <DestinationDescriptionView
              threshold={MEDIUM_COLLAPSE_HEIGHT}
              analytics={analytics}
              description={destinationDescription}
              teaser={teaser}
            />
          </ViewMedium>
        </Viewport>
      </div>
    );
  }
}

export const DestinationDescriptionView = (props: DestinationDescriptionViewProps) => {
  return (
    <>
      {Boolean(props.teaser) && (
        <p
          role="heading"
          aria-level={2}
          className="uitk-cell uitk-type-400 all-b-margin-three uitk-type-medium"
        >
          {props.teaser}
        </p>
      )}

      <UitkExpandoPeek
        collapseHeight={props.threshold}
        collapseLabel={formatText("read.less.label")}
        expandLabel={formatText("read.more.label")}
        threshold={props.threshold}
        analytics={props.analytics}
      >
        {props.description}
      </UitkExpandoPeek>
    </>
  );
};

export default DestinationDescription;
